import React, { Component } from 'react';
import Moment from 'react-moment';

const Clock = () =>  {
    return (
        <Moment interval={1000} format="HH:mm"/>
    );
}

export default Clock;